import { Auditable, ClaimUserTenant, QueryParams, SortOption, SortParams, UserRoleTenant } from "..";

export interface User extends Auditable {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    mfaOptionId: number;
    mfaEnabled: boolean;
    mfaSetupComplete: boolean;
    impersonateeId?: number;
    territoryId?: number;

    userRoleTenants?: UserRoleTenant[];
    claimUserTenants?: ClaimUserTenant[];
}

export const DefaultUserQueryParams: QueryParams = {
    firstName: "",
    lastName: "",
    emailAddress: "",
};

export const DefaultUserSortParams: SortParams = {
    orderBy: "lastName",
    orderDesc: "false",
};

// not currently used but could be used for a dropdown to sort
export const userSortOptions: SortOption[] = [
    { value: "lastName", label: "Last Name (A-Z)", orderDesc: "false" },
    { value: "lastName", label: "Last Name (Z-A)", orderDesc: "true" },
    { value: "firstName", label: "First Name (A-Z)", orderDesc: "false" },
    { value: "firstName", label: "First Name (Z-A)", orderDesc: "true" },
    { value: "emailAddress", label: "Email Address (A-Z)", orderDesc: "false" },
    { value: "emailAddress", label: "Email Address (Z-A)", orderDesc: "true" },
];
